<template>
  <div class="action-button-wrapper inline-block w-fit">
    <NuxtLink
      :to="to"
      class="action-button editorial-pill primary h-full w-full text-center"
    >
      <slot />
    </NuxtLink>
  </div>
</template>

<script setup lang="ts">
withDefaults(defineProps<{
  to?: string
  variant?: 'primary' | 'info' | 'orange' | 'blue' | 'green' | 'yellow' | 'red'
}>(), {
  variant: 'primary'
})
</script>
